export enum VoteEnum {
  BEHIND = 0,
  AGAINST = 1
}

export enum VoteTypesEnum {
  BEHIND = 'behind',
  AGAINST = 'against'
}
